// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0{display:none}.st1{display:inline;fill:#215aa8}.st2{fill:#fff}.slidoIcon{margin:9px 0 6px 0}", ""]);
// Exports
module.exports = exports;
